import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserTokenCreateResponse } from '@zerops/zerops/core/user-token-base';

@Injectable({ providedIn: 'root' })
export class Z3HandoverApi {
  #httpClient = inject(HttpClient);

  /**
   * Mints a personal access token for a client. The secret is in this response
   * and nowhere else — the list endpoint returns names and ids only — so it is
   * handed straight to the redirect and never stored here.
   */
  create$(name: string): Observable<UserTokenCreateResponse> {
    return this.#httpClient.post<UserTokenCreateResponse>('/api/user-token', { name });
  }
}
